import PropTypes, { number } from 'prop-types'
import React from 'react'
import Link from 'next/link'
import { connect } from 'react-redux'
import ReactSVG from 'react-svg'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { getUrlParts, groupMenuItems } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'
import { getPagination } from 'SRC/modules/vehicleParts/list/selectors'
import { getFilteredFields } from 'SRC/modules/vehicleParts/filter/selectors'
import { PriceSort } from 'SRC/modules/vehicleParts/filter/components/PriceSort/PriceSort'
import { SeasonFilter } from 'SRC/modules/vehicleParts/filter/components/Gume/SeasonFilter'
import { BreadCrumbsItem } from '../BreadCrumbsItem'

const BCIcon = () => {
	return (
		<ReactSVG src='/icons/home-breadcrumbs.svg' beforeInjection={svg => {
			svg.setAttribute('style', 'width: 20px; height: auto; margin-right: 5px;')
		}} wrapper='span' className='ad-breadcrumbs__icon' />
	)
}

export const getBreadCrumbsItems = (group, filterValues, filteredFields) => {
	let urlParts = getUrlParts(group, { ...filterValues, page: 1 })

	if (!Array.isArray(urlParts)) return null

	urlParts = urlParts.filter(item => item.key !== 'strana')

	if (!group) return null

	let baseAs = '/novi-djelovi'
	let baseHref = { pathname: '/vehicleParts', query: { '0': [''] } }

	if (group !== 'svi-djelovi') {
		baseAs += `/${group}`
		baseHref.query.group = group
	}

	const groupItem = groupMenuItems.find(item => item.seo === group)

	const breadCrumbItems = [
		{ key: 'home', as: '/', href: { pathname: '/' }, text: 'Početna', isLast: false },
		{ key: 'vehicleParts', as: '/novi-djelovi', href: { pathname: '/vehicleParts', query: { '0': [''] } }, text: 'Novi djelovi', isLast: false },
	]

	if (group !== 'svi-djelovi') breadCrumbItems.push({ key: 'vehiclePartsGroup', as: baseAs, href: baseHref, text: groupItem?.title, isLast: !urlParts.length })

	let asUrl = baseAs
	let hrefUrl = baseHref

	if (urlParts.length) {
		urlParts.forEach((urlPart, i) => {
			const isLast = i === urlParts.length - 1

			console.log('BreadCrumbs urlPart', urlPart)
			console.log('BreadCrumbs isLast', isLast)

			const field = filteredFields?.data?.[urlPart[2]]?.find(item => item.slug === urlPart[1])

			console.log('BreadCrumbs field', field)

			asUrl += `/${urlPart[0]}-${urlPart[1]}`
			hrefUrl = { pathname: '/vehicleParts', query: { ...hrefUrl.query, '0': `${hrefUrl.query['0']}/${urlPart[0]}-${urlPart[1]}` } }

			console.log('BreadCrumbs asUrl', asUrl)
			console.log('BreadCrumbs hrefUrl', hrefUrl)

			breadCrumbItems.push({ key: urlPart[0], as: asUrl, href: hrefUrl, text: field?.name || '', isLast })
		})
	}

	return breadCrumbItems
}

const CountText = ({ count }) => {
	if (!count) return <span />
	if (count === 1) {
		return <span style={{ marginLeft: 'auto', fontSize: '1rem' }}><strong>1</strong> proizvod pronađen</span>
	}

	if (count === 2) {
		return <span style={{ marginLeft: 'auto', fontSize: '1rem' }}><strong>2</strong> pronađena proizvoda</span>
	}

	return <span style={{ marginLeft: 'auto', fontSize: '1rem' }}><strong>{count}</strong> pronađenih proizvoda</span>
}

const BreadCrumbs = ({ group, filterValues, filteredFields, pagination, isMobileDevice, showParts }) => {
	const breadCrumbItems = getBreadCrumbsItems(group, filterValues, filteredFields)

	console.log('BreadCrumbs breadCrumbItems', breadCrumbItems)
	const lastBc = breadCrumbItems[breadCrumbItems.length - 1]

	return (
		<div className='ad-breadcrumbs ad-breadcrumbs__ads_list ad-breadcrumbs__vehicle-parts'>
			<BCIcon />

			{breadCrumbItems.map((breadCrumbItem, i) => (
				<BreadCrumbsItem
					key={breadCrumbItem.key}
					as={breadCrumbItem.as}
					href={breadCrumbItem.href}
					text={breadCrumbItem.text}
					isLast={i === breadCrumbItems.length - 1}
				/>
			))}

			{isMobileDevice || !showParts ? null : <CountText count={pagination?.totalCount || 0} />}

			{!isMobileDevice ? (
				<div className='vehicle-parts-breadcrumbs-container'>
					{group !== 'gume' ? (
						<div className='vehicle-parts-breadcrumbs-container__title_desc'>
							{filteredFields?.seo?.title ? <h1>{filteredFields?.seo?.title}</h1> : null}
							{filteredFields?.seo?.description ? <h2>{filteredFields?.seo?.description}</h2> : null}
						</div>
					) : (
						<div className='vehicle-parts-breadcrumbs-container__title_desc' style={{ width: '100%' }}>
							{filteredFields?.seo?.title ? <h1>{filteredFields?.seo?.title}</h1> : null}
						</div>
					)}

					{showParts && pagination?.totalCount ? (
						<>
							{group === 'gume' && <SeasonFilter />}
							<PriceSort />
						</>
					) : null}
				</div>
			) : (
				<div className='vehicle-parts-breadcrumbs-container vehicle-parts-breadcrumbs-container-mobile'>
					{showParts && pagination?.totalCount ? (
						<>
							{group === 'gume' && <SeasonFilter />}
							<PriceSort isMobileDevice={isMobileDevice} />
						</>
					) : null}
				</div>
			)}

		</div>
	)
}

BreadCrumbs.propTypes = {
	group: PropTypes.oneOf(['svi-djelovi', 'gume', 'akumulatori', 'ulja-i-maziva', 'filteri', 'karoserija', 'univerzalno', 'alati-i-oprema']).isRequired,
	pagination: PropTypes.shape({
		totalCount: PropTypes.number
	}).isRequired,
	filteredFields: PropTypes.oneOf([
		PropTypes.shape({
			data: PropTypes.shape({
				group: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				category: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				car_brand: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				car_model: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				year: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				vehicle_type: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				car_model_engine_info: PropTypes.arrayOf(PropTypes.shape({
					model: PropTypes.string.isRequired,
					tip_motora: PropTypes.string.isRequired,
					snaga_kw: PropTypes.string.isRequired,
					snaga_ks: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				}))
			}),
			seo: PropTypes.shape({
				title: PropTypes.string,
				description: PropTypes.string
			})
		}),
		PropTypes.shape({
			data: PropTypes.shape({
				width: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				height: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				diameter: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				manufacturer: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				season: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				vehicle_type: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				}))
			})
		}),
		PropTypes.shape({
			data: PropTypes.shape({
				voltage: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				capacity: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				width: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				height: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				length: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				manufacturer: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				}))
			})
		}),
		PropTypes.shape({
			data: PropTypes.shape({
				category: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				manufacturer: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
			})
		})
	]).isRequired,
	filterValues: PropTypes.oneOf([
		PropTypes.shape({
			car_brand: PropTypes.string,
			car_model: PropTypes.string,
			group: PropTypes.string,
			category: PropTypes.string,
			year: PropTypes.string,
			vehicle_type: PropTypes.string
		}),
		PropTypes.shape({
			width: PropTypes.string,
			height: PropTypes.string,
			diameter: PropTypes.string,
			manufacturer: PropTypes.string,
			season: PropTypes.string,
			tire_vehicle_type: PropTypes.string
		}),
		PropTypes.shape({
			voltage: PropTypes.string,
			capacity: PropTypes.string,
			width: PropTypes.string,
			height: PropTypes.string,
			length: PropTypes.string,
			manufacturer: PropTypes.string
		}),
		PropTypes.shape({
			category: PropTypes.string,
			manufacturer: PropTypes.string
		})
	]).isRequired,
	showParts: PropTypes.bool
}

BreadCrumbs.defaultProps = {
	showParts: true
}

CountText.propTypes = {
	count: PropTypes.number.isRequired,
}

const mapStateToProps = state => {
	return {
		pagination: getPagination(state),
		filteredFields: getFilteredFields(state),
		isMobileDevice: getIsMobileDevice(state)
	}
}

export default connect(mapStateToProps)(BreadCrumbs)
